export const PROXY_URL = `${import.meta.env.VITE_API_ENDPOINT}/fhir/`;
